var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBenefits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6562 1.94531C14.6562 2.01562 15.1016 3.9375 13.8125 5.76562C12.9219 7.07812 11.4453 7.99219 9.40625 8.53125C8.98438 8.64844 8.67969 9.04688 8.67969 9.49219C8.67969 10.0547 9.125 10.5 9.6875 10.5H9.80469C10.4141 10.5 10.9297 11.0156 10.9297 11.625C10.9297 11.8359 10.7891 12 10.5781 12H5.35156C5.16406 12 5 11.8359 5 11.625C5 11.0156 5.49219 10.5 6.125 10.5H6.21875C6.78125 10.5 7.25 10.0547 7.22656 9.49219C7.22656 9.04688 6.94531 8.64844 6.5 8.53125C4.46094 7.99219 2.98438 7.07812 2.11719 5.76562C0.875 3.9375 1.32031 2.01562 1.32031 1.94531C1.39062 1.6875 1.625 1.5 1.88281 1.5H4.25C4.22656 1.21875 4.22656 0.960938 4.25 0.726562C4.25 0.328125 4.57812 0 5 0H10.9766C11.3984 0 11.7266 0.328125 11.7266 0.726562C11.75 0.960938 11.75 1.21875 11.7266 1.5H14.0938C14.3516 1.5 14.5859 1.6875 14.6562 1.94531ZM3.05469 5.15625C3.59375 5.97656 4.46094 6.60938 5.60938 7.07812C4.74219 5.71875 4.39062 4.03125 4.25 2.625H2.375C2.35156 3.1875 2.39844 4.19531 3.05469 5.15625ZM12.9219 5.15625C13.5781 4.19531 13.625 3.1875 13.6016 2.625H11.7266C11.5859 4.03125 11.2344 5.71875 10.3672 7.07812C11.5156 6.60938 12.3828 5.97656 12.9219 5.15625Z",
    fill: "#D6D8E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefits);
export default __webpack_public_path__ + "static/media/icon-benefits.714ed21944725d80faeaf4bb734eaef4.svg";
export { ForwardRef as ReactComponent };